// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4d5bd068","455":"52aefefe","977":"f094ced8"}[chunkId] + ".chunk.js";
};